import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = [
    "Select Template",
    "Upload Media",
    "Parameters",
    "Preview",
    "Recipients",
];

const accent = "#111827";

export default function TestMessageSteppers({ currentStep }) {
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                px: { xs: 0.5, sm: 1 },
                py: 1.5,
                borderRadius: 2,
                border: "1px solid rgba(0,0,0,0.08)",
                backgroundColor: "rgba(255,255,255,0.9)",
                overflowX: "auto",
            }}
        >
            <Stepper
                activeStep={currentStep}
                alternativeLabel
                sx={{
                    width: "100%",
                    minWidth: 0,
                    "& .MuiStepConnector-line": {
                        borderColor: "rgba(0,0,0,0.12)",
                    },
                    "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line, & .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
                        borderColor: accent,
                    },
                    "& .MuiStepIcon-root": {
                        color: "rgba(0,0,0,0.18)",
                    },
                    "& .MuiStepIcon-root.Mui-active, & .MuiStepIcon-root.Mui-completed": {
                        color: accent,
                    },
                    "& .MuiStepLabel-labelContainer": {
                        maxWidth: { xs: 72, sm: 96, md: 120 },
                    },
                    "& .MuiStepLabel-label": {
                        fontWeight: 600,
                        fontSize: { xs: "0.65rem", sm: "0.72rem", md: "0.78rem" },
                        color: "text.secondary",
                        whiteSpace: "normal",
                        lineHeight: 1.2,
                        overflowWrap: "anywhere",
                    },
                    "& .MuiStepLabel-label.Mui-active, & .MuiStepLabel-label.Mui-completed": {
                        color: "text.primary",
                        fontWeight: 700,
                    },
                }}
            >
                {steps.map((label) => (
                    <Step key={label} sx={{ minWidth: 0, px: { xs: 0, sm: 0.5 } }}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
}
